// extracted by mini-css-extract-plugin
export default {"icon":"DraftCourse_icon__uB5s7"};